import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { useRouteMatch, useParams } from "react-router-dom";
import LinesEllipsis from 'react-lines-ellipsis'
import { fetchTemplates } from "actions/templates";

import _ from 'lodash';
import cx from 'classnames';

import { getBaseUrl } from "services/util";

import {
  Row,
  Col,
  Offcanvas,
  Dropdown,
  Form,
  Button,
  Image
} from "react-bootstrap";

import { IKImage } from "imagekitio-react";
import { Loader } from "components/ApplicationLoader";
import Tooltip from "components/Tooltip";
import InfiniteScroll from "components/InfiniteScroll";
import { PPTXButton } from './../pptxButton';

import styles from './template.module.scss';

export const CreateStoryboard = ({ show, onClose }) => {
  const dispatch = useDispatch();

  let { url } = useRouteMatch();
  let baseUrl = getBaseUrl(url);
  const {listId} = useParams();

  const [state, setState] = useState({
    details: true,
    template: false,
    storyboardName:'Untitled-1',
    list: listId
  });


  useEffect(() => {
    setState({
      ...state,
      template: true
    });

    if (show) {
      let request = {
        type: "", category: "", industry: "", sort: "created_date", order: "DESC"
      }
      dispatch(fetchTemplates(0, 20, request ));
    }
  }, [show]);

  const handleNameChange = (e) => {
    var name = e.target.value;

    setState(state => {
      return {
        ...state,
        storyboardName: name
      }
    });
  }

  const handleClose = () =>{
    setState({
      ...state,
      storyboardName:'Untitled-1',
      template: false
    });

    onClose()
  }

  const handleCreateStoryboard = (template) => {
    var templateUrl = `${baseUrl}/storyboards/templates/${template.id}/create?name=${state.storyboardName}`;

    if(listId) {
       templateUrl = `${templateUrl}&list=${listId}`;
    }

    const win = window.open(templateUrl, "_blank");
    win.focus();
    handleClose();
  }

  return (
    <>
      <Offcanvas className={cx(styles.createStoryboard, {
        [styles.fullscreen]: state.template
      })} show={show && state.template} placement="end">
        <TemplateView storyboardName={state.storyboardName} onBack={() => {handleClose()}} onNameChange={handleNameChange} onFinish={handleCreateStoryboard} />
      </Offcanvas>
    </>
  );
}


function TemplateView({ onBack, onFinish, storyboardName, onNameChange }) {
  const dispatch = useDispatch();

  const loading = useSelector(state => _.get(state, 'templates.loading',false));
  const templates = useSelector(state => _.get(state, 'templates.items'));
  const pagination = useSelector(state => _.get(state, 'templates.pagination'));
  const [overlayView,setOverlayView]= useState('');
  const hasMoreItems = _.get(pagination, "current") < _.get(pagination, "totalPages") - 1;

  const [contentType, setContentType] = useState("");
  const [categoryTypes, setCategoryTypes] = useState([{ type: "All Templates", value: "" }]);
  const [industryTypes,setIndustryTypes] = useState([{ type: 'All', value: "" }]);
  const [selectedFilters,setSelectedFilters] = useState({contentType: "", categoryType: "", industryType: "", sortType: "created_date", sortOrder: "DESC"});

  const [newStoryboardConfig, setNewStoryboardConfig] = useState({});

  const subscription = useSelector(state => _.get(state, 'workspaces.workspace.item.subscription'));

  const contentTypeOptions = [
    { 
      id: 'blank_interactive_template',
      filterName: "contentType",
      filterValue: "INTERACTIVE_CONTENT",
      label: "Interactive Content",
      image: "/images/interactive.svg",
      active: "/images/interactive_active.svg",
      className: "interactiveImg",
      enabled: _.get(subscription, 'interactiveContentEnabled', false)
    },
    {
      id: 'blank_landing_page_template',
      filterName: "contentType",
      filterValue: "LANDING_PAGE",
      label: "Landing Page",
      image: "/images/landing.svg",
      active: "/images/landing_active.svg",
      className: "landingImg",
      enabled: _.get(subscription, 'landingPageEnabled', false)
    },
    {
      id: 'blank_resource_center_template',
      filterName: "contentType",
      filterValue: "RESOURCE_CENTER",
      label: "Resource Center",
      image: "/images/resource.svg",
      active: "/images/resource_active.svg",
      className: "resourceImg",
      enabled: _.get(subscription, 'resourceCenterEnabled', false)
    }
  ];

  const sortByOptions = [
    {
      type: 'Name',
      value: 'Name'
    },
    {
      type: 'Date',
      value: 'created_date'
    }
  ]

  const loadMoreTemplates = () => {
    const nextPage = pagination.current + 1;
    if (nextPage >= pagination.totalPages) {
      return;
    }

    handleFetchTemplates(nextPage);
  }

  const handleFetchTemplates = (page) => {
    let request = {
       type: selectedFilters.contentType, 
       category: selectedFilters.contentType !== "RESOURCE_CENTER" ? selectedFilters.categoryType : "", 
       industry: selectedFilters.industryType, 
       sort: selectedFilters.sortType, 
       order: selectedFilters.sortOrder
    }

    dispatch(fetchTemplates(page, 20, request));
  }

  useEffect(()=>{
    handleFetchTemplates(0);
  },[selectedFilters])

  useEffect(() => {
    fetchCategoryOptions();
    fetchIndustriesOptions();
  }, [templates]);

  const fetchCategoryOptions = () => {
      var templateCategories = templates.map(template => {

          if(template.categories && template.categories.length != 0){
            let categoryItems = template.categories.map((category)=>{
                  if(category && category.length != 0){
                    return{ type: category, value: category };
                  }
            })
            return categoryItems;
          }    
      })

      var data = _.compact(templateCategories).flat();

      data = [
        ...categoryTypes,
        ...data
      ]

      data = _.uniqBy(data, 'type');
      setCategoryTypes(data);
  }

  const fetchIndustriesOptions =()=>{
      var industryList = templates.map(template => {
        if(template.industries && template.industries.length != 0){
          let industryOptions = template.industries.map((industry)=>{
                if(industry && industry.length != 0){
                  return{ type: industry, value: industry };
                }
          })
          return industryOptions;
        }    
      })

      var data = _.compact(industryList).flat();

      data = [
        ...industryTypes,
        ...data
      ]

      data = _.uniqBy(data, 'type');
      setIndustryTypes(data);
  }

  const handleContentTypeChange = ({id, filterName, filterValue, label}) => {
    if(!_.isEqual(filterValue, selectedFilters.contentType)){
      setNewStoryboardConfig({id: id});
      onFilterChange(filterName, filterValue);
      setContentType(label);
    }
    else{
      setNewStoryboardConfig({});
      onFilterChange(filterName, '');
      setContentType('All');
    }
  }

  const handleCreateTemplate = (useTemplate) => {
    setOverlayView('')
    onFinish(useTemplate || newStoryboardConfig);
  }

  const onClickOutsideListener = () => {
    setOverlayView('')
    document.removeEventListener("click", onClickOutsideListener)
  }

  const handleCancel = () => {
    onBack()
    let request={
      type: "", category: "", industry: "", sort: "created_date", order: "DESC" 
    };
    dispatch(fetchTemplates(0, 20, request));
  }

  const RenderTemplateType = ({type}) => {
    var templateType = null;
    var contentData = type.replaceAll('_', ' ').toLowerCase();

    switch (type) {
      case 'INTERACTIVE_CONTENT':
        templateType=(
          <div className={styles.templateTypeWrapper}>
            <i className={cx("cleverstory-Interactive")} />
            <span className={styles.contentType}>{contentData}</span>
          </div>
        )
        break;

      case 'LANDING_PAGE':
          templateType=(
            <div className={styles.templateTypeWrapper}>
              <i className={cx("cleverstory-landing-page")} />
              <span className={styles.contentType}>{contentData}</span>
            </div>
          )
        break;  

      case 'RESOURCE_CENTER':
          templateType=(
            <div className={styles.templateTypeWrapper}>
              <i className={cx("cleverstory-resource-center")} />
              <span className={styles.contentType}>{contentData}</span>
            </div>
          )
        break;     
    
      default: templateType=(<div></div>)
        break;
    }

    return templateType;
  }

  const CustomFilterDropdown = React.forwardRef(({ children, onClick }, ref) => (
    <span
      ref={ref}
      onClick={(e) => {
        e.preventDefault();
        onClick(e);
      }}
      className={styles.dropDownToggle}
    >
      {children}
      <i className={cx('cleverstory-drop-down')}/>
    </span>
  ));

  const CustomDropdown = ({dropdownName, filterType, filterOptions, selectedFilterType, sortOrder}) =>{
    return(
        <aside className={styles.filterContainer}>
          <label className={styles.filterLabel}>{dropdownName} 
              {sortOrder && <img onClick={()=>onFilterChange("sortOrder",selectedFilters.sortOrder === "ASC" ? "DESC" : "ASC")} className={cx(styles.sortIcon, selectedFilters.sortOrder === "ASC" ? styles.ascending : styles.descending)} alt="sortIcon" src='/images/sortIcon.svg' />} 
          </label>
          <Dropdown className={styles.storboardTypeDropdown}>
            <Dropdown.Toggle as={CustomFilterDropdown} id="dropdown-custom-components">
              { 
                filterOptions.map((option)=> {
                    if(option.value == selectedFilterType){
                        return option.type
                    }
                })
              }
            </Dropdown.Toggle>
            <Dropdown.Menu>
              {
                filterOptions.map((option, index)=> {
                  return (
                    <Dropdown.Item active={option.value == selectedFilterType} onClick={ ()=>onFilterChange(filterType,option.value) }  key={index} eventKey={index}>{option.type}</Dropdown.Item>
                  )
                })
              }
            </Dropdown.Menu>
          </Dropdown>
        </aside>
    )
  }

  const onFilterChange = (type, value) => {
    setSelectedFilters((state) => {
      return {
        ...state,
        [type]: value,
      };
    });
  };

  return (
    <section className={styles.storyboardTemplates} >
      <Row className={styles.row}>
        <Col className={styles.sidePanel} xs='5' lg='4'>
          <Button className={styles.backButton} variant="info" onClick={handleCancel} >
            <i className={cx("cleverstory-close")} />
          </Button>
          <header className={styles.header}>
            <h1 className={styles.title}>Create New Storyboard</h1>
            <span className={styles.description}>Select a template from the library or create <br></br> something from scratch.</span>
          </header>
          <div className={styles.blankTemplate}>
            <div className={styles.customContainer}>
                <h6 className={styles.typesTitle}>TITLE</h6>
                <Form.Control
                  value={storyboardName}
                  onChange={onNameChange}
                  className={styles.name}
                  placeholder="Storyboard name"
                />
            </div>

            <div className={styles.customContainer}> 
                <h6 className={styles.typesTitle}>CONTENT TYPE</h6>     
                <div className={styles.storyBoardFormat} >

                {contentTypeOptions.map((option)=> {
                    return(
                      <>
                      {option.enabled &&
                        <Button variant="info" className={cx(styles.scratchTemplate, { [styles.activeBtn]: selectedFilters.contentType === option.filterValue })} onClick={() => handleContentTypeChange(option)}>
                          <div className={styles.imgBox}>
                            <img className={styles[option.className]} src={selectedFilters.contentType === option.filterValue ? option.active : option.image} />
                          </div>
                          <div className={styles.titleBox}>
                            <span>{option.label}</span>
                          </div>
                        </Button>
                      }
                      </>
                    )
                  })
                }
                </div>
            </div>
            
            {selectedFilters && selectedFilters.contentType === 'RESOURCE_CENTER' ? 
                <>
                  <div className={styles.customContainer}>
                      <h6 className={styles.typesTitle}>INDUSTRY</h6>
                      <div className={styles.templateTypes}>
                        <div className={styles.listView}>
                          {
                            (industryTypes || []).map((data, id) => {
                              const active = _.isEqual(data.value, selectedFilters.industryType);
                              return (
                                <Button variant="light" key={id} onClick={() => onFilterChange('industryType', data.value)} className={cx(styles.templateList, { [styles.active]: active })}>{data.type}</Button>
                              )
                            })
                          }
                        </div>
                      </div>
                  </div>
                </>
                :
                <>
                  <div className={styles.customContainer}>
                      <h6 className={styles.typesTitle}>USE CASE</h6>
                      <div className={styles.templateTypes}>
                        <div className={styles.listView}>
                          {
                            (categoryTypes || []).map((data, id) => {
                              const active = _.isEqual(data.value, selectedFilters.categoryType);
                              return (
                                <Button variant="light" key={id} onClick={() => onFilterChange('categoryType', data.value)} className={cx(styles.templateList, { [styles.active]: active })}>{data.type}</Button>
                              )
                            })
                          }
                        </div>
                      </div>
                  </div>
                </>
            }
            
            <Button className={cx(styles.createButton,{[styles.disabled] : selectedFilters.contentType === ''})} onClick={() => handleCreateTemplate()} variant="light">
              <i className='cleverstory-plus' /> Create from scratch
            </Button>
          </div>
        </Col>
        
        <Col className={styles.templatesPane} xs='7' lg='8'>
          <div className={styles.headerContainer}>
              <div>
                <h4 className={styles.mainHeading}>{contentType ? contentType : "All"}</h4>
                <h4 className={styles.heading}>Templates</h4>
              </div>

              <div className={styles.filtersContainer}>
                {selectedFilters.contentType !== 'RESOURCE_CENTER' && 
                    <CustomDropdown dropdownName="Industry:" filterOptions={industryTypes} filterType="industryType" selectedFilterType={selectedFilters.industryType}/>
                }
                <CustomDropdown dropdownName="Sort By:" filterOptions={sortByOptions} filterType="sortType" selectedFilterType={selectedFilters.sortType} sortOrder={selectedFilters.sortOrder}/>
              </div>
          </div>

          {loading && templates.length === 0 &&
            <Loader className={styles.loadingAnimation} title="Loading templates..." />
          }

          {templates.length > 0 &&
            <InfiniteScroll
              className={styles.templates}
              loading={loading}
              hasMore={hasMoreItems}
              loadMore={() => {
                loadMoreTemplates();
              }}>

                {templates.map(template => {
                  const icon = _.get(template, 'icon.url');
                  const liveSite = _.get(template, 'url');

                  return (
                    <div key={template.id} className={styles.template}>
                      <div className={styles.innerContainer}>
                          {icon &&
                            <IKImage
                              onClick={() => setOverlayView(template.id)}
                              className={styles.icon}
                              path={icon}
                              transformation={[{
                                "width": "600"
                              }]}
                            />
                          }
                          {!icon &&
                            <img onClick={()=>setOverlayView(template.id)} className={styles.icon} src={'/images/storyboard.png'} alt="" />
                          }
              
                          <div className={styles.details} >
                            <div className={styles.top}>
                              <span className={styles.title}><LinesEllipsis text={template.name} maxLine='2' ellipsis='...' /> </span>
                            </div>

                            <div>
                                <div className={styles.badgeContainer}>
                                  {
                                    template.type !== 'RESOURCE_CENTER' && template.categories && template.categories.map((category,index,categoriesAll)=>{
                                      if(index < 2){
                                        return <label className={cx(styles.badges,styles.categories)}>{category}</label>
                                      }
                                      else if(index == 2){
                                        return <label className={cx(styles.badges,styles.categories)}>{`+${categoriesAll.length - 2}`}</label>
                                      }
                                    })
                                  }
                                </div>

                                <div className={styles.badgeContainer}>
                                  {
                                      template.industries && template.industries.map((industry,index,industryAll)=>{
                                        if(index < 2){
                                          return <label className={cx(styles.badges,styles.industries)}>{industry}</label>
                                        }
                                        else if(index == 2)
                                          return <label className={cx(styles.badges,styles.industries)}>{`+${industryAll.length - 2}`}</label>
                                      })
                                    }
                                </div>
                            </div>
                            
                            <div className={styles.actions}>
                              <RenderTemplateType type={template.type}/>
                              <div className={styles.buttonsContainer}>
                                <Tooltip placement="top" content="Edit">
                                  <Button variant="info" className={styles.actionButton} onClick={() => handleCreateTemplate({id: template.id})}>
                                    <i className={cx("cleverstory-plus")} />
                                  </Button>
                                </Tooltip>

                                {liveSite && <Tooltip placement='top' content='Preview'>
                                  <Button variant="info" onClick={() => window.open(liveSite, '_blank')}>
                                    <i className={cx("cleverstory-view")} />
                                  </Button>
                                </Tooltip>}
                              </div>
                            </div>
                          </div>
                          { overlayView === template.id &&
                            <div onMouseLeave={() => { document.addEventListener("click", onClickOutsideListener)}} key={template.id} className={styles.viewOverlay}>
                              <Button className={styles.viewButton} onClick={() => window.open(liveSite, '_blank')} variant="primary">View</Button>
                              <Button className={styles.editButton} onClick={() => handleCreateTemplate({id:template.id})} variant="primary">Use</Button>
                            </div>
                          }
                      </div>
                    </div>
                  )
                })}
            </InfiniteScroll>
          }

          {!loading && templates.length === 0 &&
              <div className={styles.emptyMessageContainer}>
                  <div className={styles.emptyMessage}>
                    <Image className={styles.emptyImage} src="/images/emptyUser.png" />
                    <div className={styles.errorMessageContent}>
                      <div className={styles.errorMessageTitle}>
                        <h2>No man<span>,</span><br /></h2>
                        <h2>No mouse<span>,</span><br /></h2>
                      </div>
                      <div className={styles.errorMessageSubText}>
                        <span>It's an empty<br />house.<br /></span>
                      </div>
                      <Button
                        type="submit"
                        variant="primary"
                        className={styles.inviteButton}
                        onClick={()=>{ setSelectedFilters({contentType: "", categoryType: "", industryType: "", sortType: "created_date", sortOrder:"DESC" }) }}
                      >
                        Reset Filters
                      </Button>
                    </div>
                  </div>
              </div>
          }
        </Col>
      </Row>
    </section>
  )
}
